import { render } from "./PortalCases.vue?vue&type=template&id=22707206&ts=true"
import script from "./PortalCases.vue?vue&type=script&lang=ts"
export * from "./PortalCases.vue?vue&type=script&lang=ts"

import "./PortalCases.vue?vue&type=style&index=0&id=22707206&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__